import React from "react";
import { Image, Upload, Search, Edit, Save } from "lucide-react";

export default function AdminDesigns({
  newDesign,
  setNewDesign,
  addDesign,
  designs,
  editDesignId,
  setEditDesignId,
  editDesign,
  setEditDesign,
  saveEditDesign,
  startEditDesign,
  delDesign,
  toggleDesign,
  designGroups,
  designCats,
  designGroup,
  setDesignGroup,
  designPage,
  setDesignPage,
  designSearch,
  setDesignSearch,
  designCat,
  setDesignCat,
  statusFilter,
  setStatusFilter,
  handleUpload,
  handleFileDrop,
  handleImageArrayUpload,
  removeImageAt,
  handleImageArrayFile,
  handleUploadFile,
}) {
  return (
    <>
      {/* =========================
          DESIGNS
      ========================= */}
        <div
          className="mt-6"
          data-testid="admin-designs"
        >
          {/* ADD DESIGN */}

          <form onSubmit={addDesign} className="card-pmt p-5">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              {/* DESIGN DETAILS */}
              <div className="lg:col-span-2 space-y-5">
                <div>
                  <div className="overline">Design Information</div>
                  <p className="text-sm text-stone-600 mt-1">
                    Add the design details, pricing and customer-facing information.
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <div className="label-pmt">Design ID *</div>
                    <input
                      required
                      placeholder="PMT-131"
                      className="input-pmt"
                      value={newDesign.design_id}
                      onChange={(e) => setNewDesign({ ...newDesign, design_id: e.target.value })}
                    />
                  </div>

                  <div>
                    <div className="label-pmt">Design Name *</div>
                    <input
                      required
                      className="input-pmt"
                      placeholder="e.g. Tamil Pride"
                      value={newDesign.name}
                      onChange={(e) => setNewDesign({ ...newDesign, name: e.target.value })}
                    />
                  </div>

                  <div>
                    <div className="label-pmt">Product Type *</div>
                    <select
                      className="input-pmt"
                      value={newDesign.group}
                      onChange={(e) => setNewDesign({ ...newDesign, group: e.target.value })}
                    >
                      {designGroups.map((group) => (
                        <option key={group} value={group}>{group}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <div className="label-pmt">Design Category *</div>
                    <select
                      className="input-pmt"
                      value={newDesign.category}
                      onChange={(e) =>
                        setNewDesign({
                          ...newDesign,
                          category: e.target.value,
                          custom_category:
                            e.target.value === "Custom"
                              ? newDesign.custom_category
                              : "",
                        })
                      }
                    >
                      {designCats.map((c) => (
                        <option key={c} value={c}>{c}</option>
                      ))}
                      <option value="Custom">Custom</option>
                    </select>
                    {newDesign.category === "Custom" && (
                      <input
                        className="input-pmt mt-2"
                        placeholder="Enter custom category"
                        value={newDesign.custom_category || ""}
                        onChange={(e) =>
                          setNewDesign({
                            ...newDesign,
                            custom_category: e.target.value,
                          })
                        }
                      />
                    )}
                  </div>

                  <div>
                    <div className="label-pmt">HSN Code</div>
                    <input
                      className="input-pmt"
                      placeholder="e.g. 6109"
                      value={newDesign.hsn_code}
                      onChange={(e) => setNewDesign({ ...newDesign, hsn_code: e.target.value })}
                    />
                  </div>

                  <div>
                    <div className="label-pmt">GST Rate (%)</div>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="input-pmt"
                      placeholder="Auto (5 / 12)"
                      value={newDesign.gst_rate}
                      onChange={(e) => setNewDesign({ ...newDesign, gst_rate: e.target.value })}
                    />
                    <div className="text-[10px] text-stone-500 mt-1">
                      Leave blank to use the configured apparel rate.
                    </div>
                  </div>

                  <div>
                    <div className="label-pmt">Available Colours</div>
                    <input
                      className="input-pmt"
                      placeholder="Black, White, Navy"
                      value={newDesign.colors}
                      onChange={(e) => setNewDesign({ ...newDesign, colors: e.target.value })}
                    />
                    <div className="text-[10px] text-stone-500 mt-1">
                      Example: Black, White, Navy
                    </div>
                  </div>

                  <div>
                    <div className="label-pmt">Quality / GSM + Price</div>
                    <input className="input-pmt" placeholder="180 GSM | 399, 240 GSM | 449" value={newDesign.qualities} onChange={(e) => setNewDesign({ ...newDesign, qualities: e.target.value })} />
                    <div className="text-[10px] text-stone-500 mt-1">Format: GSM | final base price. Printing/personalisation charges remain separate.</div>
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <div className="label-pmt">Default / Fallback Price (₹)</div>
                      <input
                        type="number"
                        min="0"
                        step="1"
                        className="input-pmt"
                        placeholder="399"
                        value={newDesign.price}
                        onChange={(e) => setNewDesign({ ...newDesign, price: e.target.value })}
                      />
                      <div className="text-[10px] text-stone-500 mt-1">Optional when GSM-specific prices are configured.</div>
                    </div>
                    <div>
                      <div className="label-pmt">Discount (%)</div>
                      <input type="number" min="0" max="100" step="1" className="input-pmt" placeholder="0"
                        value={newDesign.discount_percent}
                        onChange={(e) => setNewDesign({ ...newDesign, discount_percent: e.target.value })} />
                      <div className="text-[10px] text-stone-500 mt-1">Applies to the base price and each GSM price.</div>
                    </div>
                    <div>
                      <div className="label-pmt">Delivery Charge (₹)</div>
                      <input
                        type="number"
                        min="0"
                        step="1"
                        className="input-pmt"
                        placeholder="60"
                        value={newDesign.delivery_charge}
                        onChange={(e) => setNewDesign({ ...newDesign, delivery_charge: e.target.value })}
                      />
                    </div>
                  </div>
                </div>

                <div className="sm:col-span-2">
                  <label className="text-xs flex items-center gap-2">
                    <input
                      type="checkbox"
                      checked={!!newDesign.featured}
                      onChange={(e) => setNewDesign({ ...newDesign, featured: e.target.checked })}
                    />
                    Feature this design on the homepage
                  </label>
                  <div className="text-[10px] text-stone-500 mt-1">
                    Featured designs are shown in the homepage Design Library.
                  </div>
                </div>

                <div>
                  <div className="label-pmt">Design Image *</div>
                  <div className="flex flex-col sm:flex-row gap-2">
                    <input
                      className="input-pmt flex-1"
                      placeholder="Paste image URL, or upload →"
                      value={newDesign.image_url}
                      onChange={(e) => setNewDesign({ ...newDesign, image_url: e.target.value })}
                    />
                    <label className="btn-outline-pmt cursor-pointer text-xs" onDragOver={(e) => e.preventDefault()} onDragEnter={(e) => e.currentTarget.classList.add("ring-2", "ring-black", "ring-offset-2")} onDragLeave={(e) => e.currentTarget.classList.remove("ring-2", "ring-black", "ring-offset-2")} onDrop={handleFileDrop((file) => handleUploadFile(file, "image_url", setNewDesign))}>
                      <Upload size={14} />
                      Upload
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={handleUpload("image_url", setNewDesign)}
                      />
                    </label>
                  </div>
                  {newDesign.image_url && (
                    <img
                      src={newDesign.image_url}
                      alt="Design preview"
                      className="mt-2 w-24 h-24 object-cover border border-[#E6DFD5]"
                    />
                  )}
                </div>

                <div>
                  <div className="label-pmt">Description</div>
                  <textarea
                    rows={4}
                    className="input-pmt"
                    placeholder="Enter design description, details, or notes..."
                    value={newDesign.description}
                    onChange={(e) => setNewDesign({ ...newDesign, description: e.target.value })}
                  />
                </div>
              </div>

              {/* DESIGN IMAGES */}
              <div className="space-y-5">
                <div className="card-pmt p-4">
                  <div className="overline">Back Image</div>
                  <div className="mt-3 flex flex-col gap-2">
                    <input
                      className="input-pmt"
                      placeholder="Paste back-side image URL"
                      value={newDesign.back_image_url}
                      onChange={(e) => setNewDesign({ ...newDesign, back_image_url: e.target.value })}
                    />
                    <label className="btn-outline-pmt cursor-pointer text-xs justify-center" onDragOver={(e) => e.preventDefault()} onDragEnter={(e) => e.currentTarget.classList.add("ring-2", "ring-black", "ring-offset-2")} onDragLeave={(e) => e.currentTarget.classList.remove("ring-2", "ring-black", "ring-offset-2")} onDrop={handleFileDrop((file) => handleUploadFile(file, "back_image_url", setNewDesign))}>
                      <Upload size={14} />
                      Upload Back Image
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={handleUpload("back_image_url", setNewDesign)}
                      />
                    </label>
                  </div>
                  {newDesign.back_image_url && (
                    <img
                      src={newDesign.back_image_url}
                      alt="Back preview"
                      className="mt-3 w-full aspect-square object-cover border border-[#E6DFD5]"
                    />
                  )}
                </div>

                <div className="card-pmt p-4">
                  <div className="overline">Product Images (up to 5)</div>
                  <div className="grid grid-cols-2 sm:grid-cols-5 lg:grid-cols-3 gap-2 mt-3">
                    {Array.from({ length: 5 }).map((_, index) => {
                      const image = (newDesign.images || [])[index];
                      return (
                        <div key={index} className="border border-[#E6DFD5] p-2 bg-white" onDragOver={(e) => e.preventDefault()} onDragEnter={(e) => e.currentTarget.classList.add("ring-2", "ring-black", "ring-offset-2")} onDragLeave={(e) => e.currentTarget.classList.remove("ring-2", "ring-black", "ring-offset-2")} onDrop={handleFileDrop((file) => handleImageArrayFile(file, index, setNewDesign))}>
                          {image ? (
                            <img
                              src={image}
                              alt={`View ${index + 1}`}
                              className="w-full aspect-square object-cover"
                            />
                          ) : (
                            <div className="w-full aspect-square flex items-center justify-center text-[10px] text-stone-400 bg-[#F8F5F0]">
                              View {index + 1}
                            </div>
                          )}
                          <label className="mt-2 block text-center text-[10px] uppercase font-semibold cursor-pointer" onDragOver={(e) => e.preventDefault()} onDragEnter={(e) => e.currentTarget.classList.add("ring-2", "ring-black", "ring-offset-2")} onDragLeave={(e) => e.currentTarget.classList.remove("ring-2", "ring-black", "ring-offset-2")} onDrop={handleFileDrop((file) => handleImageArrayFile(file, index, setNewDesign))}>
                            {image ? "Replace" : "Upload"}
                            <input
                              type="file"
                              accept="image/*"
                              className="hidden"
                              onChange={handleImageArrayUpload(index, setNewDesign)}
                            />
                          </label>
                          {image && (
                            <button
                              type="button"
                              className="mt-1 w-full text-[10px] text-red-600"
                              onClick={() => removeImageAt(index, setNewDesign)}
                            >
                              Remove
                            </button>
                          )}
                        </div>
                      );
                    })}
                  </div>
                  <div className="text-[10px] text-stone-500 mt-2">
                    Add up to 5 product photos. The first image is used as the main gallery image.
                  </div>
                </div>

                <div className="border-t border-[#E6DFD5] pt-4">
                  <button className="btn-primary w-full" type="submit">
                    Add Design
                  </button>
                </div>
              </div>
            </div>
          </form>



          <div className="mt-4 flex flex-wrap gap-3 items-center">
            <input
              placeholder="Search designs…"
              value={
                designSearch
              }
              onChange={(e) => {
                setDesignSearch(
                  e.target.value
                );

                setDesignPage(1);
              }}
              className="input-pmt max-w-xs"
            />

            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="input-pmt max-w-xs"
            >
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="disabled">Disabled</option>
            </select>

            <select
              aria-label="Filter by product category"
              value={designGroup}
              onChange={(e) => setDesignGroup(e.target.value)}
              className="input-pmt max-w-xs"
            >
              <option value="All">All Product Types</option>
              {designGroups.map((group) => (
                <option key={group} value={group}>{group}</option>
              ))}
            </select>

            <select
              value={
                designCat
              }
              onChange={(e) => {
                setDesignCat(
                  e.target.value
                );

                setDesignPage(1);
              }}
              className="input-pmt max-w-xs"
            >
              <option>
                All
              </option>

              {designCats.map(
                (c) => (
                  <option
                    key={c}
                    value={c}
                  >
                    {c}
                  </option>
                )
              )}
            </select>

            <span className="text-xs font-mono uppercase text-stone-500">
              {designs.total}{" "}designs
            </span>
          </div>

          {/* DESIGN CARDS */}

          <div className="mt-6 grid grid-cols-2 md:grid-cols-4 gap-3">
            {designs.items.map(
              (d) => (
                <div
                  key={
                    d.design_id
                  }
                  className="card-pmt p-3"
                >
                  <div className="flex items-center justify-between">
                    <div className="font-mono text-xs">
                      {
                        d.design_id
                      }
                    </div>

                    <span
                      className={`text-[10px] uppercase font-mono ${
                        d.active ===
                        false
                          ? "text-red-600"
                          : "text-green-700"
                      }`}
                    >
                      {d.active ===
                      false
                        ? "hidden"
                        : "active"}
                    </span>
                    {d.featured && (
                      <span className="text-[10px] uppercase font-mono text-[#D95328]">
                        featured
                      </span>
                    )}
                  </div>

                  {(d.image_url || d.images?.[0]) && (
                    <img
                      src={d.image_url || d.images[0]}
                      alt={d.name}
                      className="mt-2 w-full aspect-square object-cover border border-[#E6DFD5]"
                    />
                  )}

                  <div className="font-bold mt-2">
                    {
                      d.name
                    }
                  </div>

                  <div className="text-xs text-stone-500">
                    {
                      d.group ||
                      "Other"
                    }
                  </div>

                  <div className="text-xs text-stone-500">
                    {
                      d.category
                    }
                  </div>

                  <div className="mt-2 text-sm font-bold text-[#D95328]">
                    {d.price !=
                    null
                      ? `₹${Number(
                          d.price
                        ).toLocaleString(
                          "en-IN"
                        )}`
                      : "No price"}
                  </div>

                  <div className="mt-1 text-[11px] text-stone-500">
                    Colours:{" "}
                    {(
                      d.colors ||
                      []
                    ).join(
                      ", "
                    ) ||
                      "Not set"}
                  </div>

                  <div className="mt-2 flex flex-wrap gap-2 text-xs">
                    <button
                      onClick={() =>
                        startEditDesign(
                          d
                        )
                      }
                      className="underline"
                    >
                      Edit
                    </button>

                    <button
                      onClick={() =>
                        toggleDesign(
                          d
                        )
                      }
                      className="underline"
                    >
                      {d.active ===
                      false
                        ? "Enable"
                        : "Disable"}
                    </button>

                    <button
                      onClick={() =>
                        delDesign(
                          d.design_id
                        )
                      }
                      className="text-red-600 underline"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              )
            )}
          </div>

          {/* PAGINATION */}

          <div className="mt-4 flex gap-2 items-center">
            <button
              onClick={() =>
                setDesignPage(
                  (p) =>
                    Math.max(
                      1,
                      p - 1
                    )
                )
              }
              disabled={designPage <= 1}
              className="btn-outline-pmt text-xs py-2 disabled:opacity-40 disabled:cursor-not-allowed"
            >
              Prev
            </button>

            <span className="text-xs font-mono uppercase">
              Page{" "}
              {
                designPage
              }{" "}
              /{" "}
              {Math.max(
                1,
                Math.ceil(
                  designs.total /
                    24
                )
              )}
            </span>

            <button
              onClick={() =>
                setDesignPage(
                  (p) =>
                    Math.min(
                      Math.max(
                        1,
                        Math.ceil(
                          (designs.total || 0) / 24
                        )
                      ),
                      p + 1
                    )
                )
              }
              disabled={
                designPage >=
                Math.max(
                  1,
                  Math.ceil(
                    (designs.total || 0) / 24
                  )
                )
              }
              className="btn-outline-pmt text-xs py-2 disabled:opacity-40 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>

          {/* EDIT DESIGN MODAL */}

          {editDesign && (
            <div
              className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4"
              onClick={() => {
                setEditDesignId(
                  null
                );

                setEditDesign(
                  null
                );
              }}
            >
              <div
                className="bg-white max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto"
                onClick={(e) =>
                  e.stopPropagation()
                }
              >
                <div
                  className="font-bold uppercase text-lg mb-4"
                  style={{
                    fontFamily:
                      "Barlow Condensed, sans-serif",
                  }}
                >
                  Edit{" "}
                  {
                    editDesignId
                  }
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">

                  {/* NAME */}

                  <div>
                    <div className="label-pmt">
                      Design Name
                    </div>

                    <input
                      className="input-pmt"
                      value={
                        editDesign.name
                      }
                      onChange={(e) =>
                        setEditDesign({
                          ...editDesign,
                          name:
                            e.target
                              .value,
                        })
                      }
                    />
                  </div>

                  {/* GROUP */}

                  <div>
                    <div className="label-pmt">
                      Product Type
                    </div>

                    <select
                      className="input-pmt"
                      value={
                        editDesign.group ||
                        "Round Neck T-Shirt"
                      }
                      onChange={(e) =>
                        setEditDesign({
                          ...editDesign,
                          group:
                            e.target
                              .value,
                        })
                      }
                    >
                      {designGroups.map(
                        (
                          group
                        ) => (
                          <option
                            key={
                              group
                            }
                            value={
                              group
                            }
                          >
                            {
                              group
                            }
                          </option>
                        )
                      )}
                    </select>
                  </div>

                  {/* CATEGORY */}

                  <div>
                    <div className="label-pmt">
                      Design Category
                    </div>

                    <select
                      className="input-pmt"
                      value={
                        editDesign.category
                      }
                      onChange={(e) =>
                        setEditDesign({
                          ...editDesign,
                          category: e.target.value,
                          custom_category:
                            e.target.value === "Custom"
                              ? editDesign.custom_category
                              : "",
                        })
                      }
                    >
                      {designCats.map(
                        (c) => (
                          <option
                            key={c}
                            value={c}
                          >
                            {c}
                          </option>
                        )
                      )}
                      <option value="Custom">Custom</option>
                    </select>
                    {editDesign.category === "Custom" && (
                      <input
                        className="input-pmt mt-2"
                        placeholder="Enter custom category"
                        value={editDesign.custom_category || ""}
                        onChange={(e) =>
                          setEditDesign({
                            ...editDesign,
                            custom_category: e.target.value,
                          })
                        }
                      />
                    )}
                  </div>

                  {/* PRICE */}

                  <div>
                    <div className="label-pmt">
                      Price (₹)
                    </div>

                    <input
                      type="number"
                      min="0"
                      step="1"
                      className="input-pmt"
                      value={
                        editDesign.price ??
                        ""
                      }
                      onChange={(e) =>
                        setEditDesign({
                          ...editDesign,
                          price:
                            e.target
                              .value,
                        })
                      }
                    />
                  </div>

                  <div>
                    <div className="label-pmt">Discount (%)</div>
                    <input type="number" min="0" max="100" step="1" className="input-pmt"
                      value={editDesign.discount_percent ?? 0}
                      onChange={(e) => setEditDesign({ ...editDesign, discount_percent: e.target.value })} />
                    <div className="text-[10px] text-stone-500 mt-1">Applies to the base price and each GSM price.</div>
                  </div>

                  {/* DELIVERY CHARGE */}

                  <div>
                    <div className="label-pmt">
                      Delivery Charge (₹)
                    </div>

                    <input
                      type="number"
                      min="0"
                      step="1"
                      className="input-pmt"
                      value={
                        editDesign.delivery_charge ??
                        ""
                      }
                      onChange={(e) =>
                        setEditDesign({
                          ...editDesign,
                          delivery_charge:
                            e.target.value,
                        })
                      }
                    />

                    <div className="text-[10px] text-stone-500 mt-1">
                      Free delivery automatically for orders ₹1000+
                    </div>
                  </div>

                  {/* GST DETAILS */}

                  <div>
                    <div className="label-pmt">
                      HSN Code
                    </div>
                    <input
                      className="input-pmt"
                      placeholder="e.g. 6109"
                      value={editDesign.hsn_code || ""}
                      onChange={(e) =>
                        setEditDesign({
                          ...editDesign,
                          hsn_code: e.target.value,
                        })
                      }
                    />
                  </div>

                  <div>
                    <div className="label-pmt">
                      GST Rate (%)
                    </div>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      className="input-pmt"
                      placeholder="Auto (5 / 12)"
                      value={editDesign.gst_rate ?? ""}
                      onChange={(e) =>
                        setEditDesign({
                          ...editDesign,
                          gst_rate: e.target.value,
                        })
                      }
                    />
                  </div>

                  {/* COLOURS */}

                  <div className="sm:col-span-2">
                    <div className="label-pmt">
                      Available Colours
                    </div>

                    <input
                      className="input-pmt"
                      placeholder="Black, White, Navy"
                      value={
                        editDesign.colors ||
                        ""
                      }
                      onChange={(e) =>
                        setEditDesign({
                          ...editDesign,
                          colors:
                            e.target
                              .value,
                        })
                      }
                    />

                    <div className="text-[10px] text-stone-500 mt-1">
                      Separate colours
                      with commas
                    </div>
                  </div>

                  <div className="sm:col-span-2">
                    <div className="label-pmt">Quality / GSM + Price</div>
                    <input
                      className="input-pmt"
                      placeholder="180 GSM | 399, 240 GSM | 449"
                      value={editDesign.qualities || ""}
                      onChange={(e) =>
                        setEditDesign({
                          ...editDesign,
                          qualities: e.target.value,
                        })
                      }
                    />
                    <div className="text-[10px] text-stone-500 mt-1">
                      Format: GSM | final base price. Example: 180 GSM | 399, 240 GSM | 449.
                    </div>
                  </div>

                  {/* IMAGE */}

                  <div className="sm:col-span-2">
                    <div className="label-pmt">
                      Image
                    </div>

                    <div className="flex flex-col sm:flex-row gap-2">
                      <input
                        className="input-pmt flex-1"
                        placeholder="Paste image URL"
                        value={
                          editDesign.image_url
                        }
                        onChange={(
                          e
                        ) =>
                          setEditDesign({
                            ...editDesign,
                            image_url:
                              e.target
                                .value,
                          })
                        }
                      />

                      <label className="btn-outline-pmt cursor-pointer text-xs" onDragOver={(e) => e.preventDefault()} onDragEnter={(e) => e.currentTarget.classList.add("ring-2", "ring-black", "ring-offset-2")} onDragLeave={(e) => e.currentTarget.classList.remove("ring-2", "ring-black", "ring-offset-2")} onDrop={handleFileDrop((file) => handleUploadFile(file, "image_url", setEditDesign))}>
                        <Upload
                          size={
                            14
                          }
                        />

                        Upload

                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={handleUpload(
                            "image_url",
                            setEditDesign
                          )}
                        />
                      </label>
                    </div>

                    {editDesign.image_url && (
                      <img
                        src={
                          editDesign.image_url
                        }
                        alt="preview"
                        className="mt-2 w-24 h-24 object-cover border border-[#E6DFD5]"
                      />
                    )}
                  </div>

                  {/* DESCRIPTION */}

                                    <div className="sm:col-span-2">
                    <div className="label-pmt">
                      Back Image
                    </div>
                    <div className="flex flex-col sm:flex-row gap-2">
                      <input
                        className="input-pmt flex-1"
                        placeholder="Paste back-side image URL"
                        value={editDesign.back_image_url || ""}
                        onChange={(e) =>
                          setEditDesign({
                            ...editDesign,
                            back_image_url: e.target.value,
                          })
                        }
                      />
                      <label className="btn-outline-pmt cursor-pointer text-xs" onDragOver={(e) => e.preventDefault()} onDragEnter={(e) => e.currentTarget.classList.add("ring-2", "ring-black", "ring-offset-2")} onDragLeave={(e) => e.currentTarget.classList.remove("ring-2", "ring-black", "ring-offset-2")} onDrop={handleFileDrop((file) => handleUploadFile(file, "back_image_url", setEditDesign))}>
                        Upload
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={handleUpload(
                            "back_image_url",
                            setEditDesign
                          )}
                        />
                      </label>
                    </div>
                  </div>

<div className="sm:col-span-2">
                    
            <div className="sm:col-span-2">
              <div className="label-pmt">
                Product Images (up to 5)
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-5 gap-2 mt-2">
                {Array.from({ length: 5 }).map((_, index) => {
                  const image = (editDesign.images || [])[index];
                  return (
                    <div key={index} className="border border-[#E6DFD5] p-2 bg-white" onDragOver={(e) => e.preventDefault()} onDragEnter={(e) => e.currentTarget.classList.add("ring-2", "ring-black", "ring-offset-2")} onDragLeave={(e) => e.currentTarget.classList.remove("ring-2", "ring-black", "ring-offset-2")} onDrop={handleFileDrop((file) => handleImageArrayFile(file, index, setEditDesign))}>
                      {image ? (
                        <img
                          src={image}
                          alt={`View ${index + 1}`}
                          className="w-full aspect-square object-cover"
                        />
                      ) : (
                        <div className="w-full aspect-square flex items-center justify-center text-[10px] text-stone-400 bg-[#F8F5F0]">
                          View {index + 1}
                        </div>
                      )}
                      <label className="mt-2 block text-center text-[10px] uppercase font-semibold cursor-pointer" onDragOver={(e) => e.preventDefault()} onDragEnter={(e) => e.currentTarget.classList.add("ring-2", "ring-black", "ring-offset-2")} onDragLeave={(e) => e.currentTarget.classList.remove("ring-2", "ring-black", "ring-offset-2")} onDrop={handleFileDrop((file) => handleImageArrayFile(file, index, setEditDesign))}>
                        {image ? "Replace" : "Upload"}
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={handleImageArrayUpload(index, setEditDesign)}
                        />
                      </label>
                      {image && (
                        <button
                          type="button"
                          className="mt-1 w-full text-[10px] text-red-600"
                          onClick={() => removeImageAt(index, setEditDesign)}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
              <div className="text-[10px] text-stone-500 mt-1">
                Add up to 5 product photos. The first image is used as the main gallery image.
              </div>
            </div>

<div className="label-pmt">
                      Description
                    </div>

                    <textarea
                      rows={3}
                      className="input-pmt"
                      value={
                        editDesign.description
                      }
                      onChange={(e) =>
                        setEditDesign({
                          ...editDesign,
                          description:
                            e.target
                              .value,
                        })
                      }
                    />
                  </div>

                  {/* FEATURED */}

                  <div className="sm:col-span-2">
                    <label className="text-xs flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={!!editDesign.featured}
                        onChange={(e) =>
                          setEditDesign({
                            ...editDesign,
                            featured: e.target.checked,
                          })
                        }
                      />
                      Feature this design on the homepage
                    </label>
                    <div className="text-[10px] text-stone-500 mt-1">
                      Featured designs are shown in the homepage Design Library.
                    </div>
                  </div>

                  {/* ACTIVE */}

                  <div>
                    <label className="text-xs flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={
                          !!editDesign.active
                        }
                        onChange={(
                          e
                        ) =>
                          setEditDesign({
                            ...editDesign,
                            active:
                              e.target
                                .checked,
                          })
                        }
                      />

                      Active
                    </label>
                  </div>
                </div>

                <div className="mt-5 flex gap-3 justify-end">
                  <button
                    onClick={() => {
                      setEditDesignId(
                        null
                      );

                      setEditDesign(
                        null
                      );
                    }}
                    className="btn-outline-pmt"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={
                      saveEditDesign
                    }
                    className="btn-primary"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          )}
      </div>
    </>
  );
}
